import placeholderImage from '../images/placeholder.webp';

const ImageCard = ({ image, onRemove, fullHeight }) => {
    return (
        <div className="image-card" style={fullHeight ? {height: 'auto'} : undefined}>
            {onRemove ? (
                <button className="image-remove" onClick={() => onRemove(image.id)}>
                    {'\u00D7'}
                </button>
            ) : null}
            <img src={(image.thumbnailUrl || image.imageUrl) ? process.env.REACT_APP_MEDIA_URL + (image.thumbnailUrl || image.imageUrl) : placeholderImage} alt={image.title} />
            {!!image.title && (<div className="image-title">
                {image.title}
            </div>)}
        </div>
    );
}

export default ImageCard;